import { render, staticRenderFns } from "./XExcelImportButton.vue?vue&type=template&id=5ac20087"
import script from "./XExcelImportButton.vue?vue&type=script&lang=js"
export * from "./XExcelImportButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports